import React, {useContext} from 'react'
import {GlobalLangCtx} from '../../App'
import './ContactComp.css'

const ContactComp = () => {

    const [selLan, setSelLan] = useContext(GlobalLangCtx);
    const fLan = require(`../language_app/json_files/lang[${selLan}].json`)
    return(
        <section id='contactsComp'>
            <div className='contact_comp_main_container'>
                <h1 >
                    {fLan.Contacts.title}
                </h1>
                <div className="contents">
                    <div className="email">
                        <div className="label">{fLan.Contacts.email}</div>
                        <div id='telValue' className="emalLabel">
                            <a href="mailto:tarallo.giuseppe.dev@gmail.com"> tarallo.giuseppe.dev@gmail.com</a>
                        </div>
                    </div>
                    <div className="telephone">
                        <div className="label">{fLan.Contacts.phone}</div>
                        <div id='emailValue' className="telephoneLabel">07383360960</div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default ContactComp;